import styled, { css } from 'styled-components';
import { Box, zIndex } from '@landr/maestro';
import { StyledSectionProps, InnerWrapperProps } from './Section.types';
import sectionStyles from './themes/Section.default';

const sectionBaseStyles = css`
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    align-content: center;
    justify-content: center;
    max-width: 100%;
    position: relative;
`;

export const Section = styled.section<StyledSectionProps>`
    ${sectionBaseStyles};
    ${sectionStyles.root};
    ${({ minHeight }) => sectionStyles.minHeight[minHeight]};
    ${({ offset }) => sectionStyles.offset[offset]};
    ${({ position }) => sectionStyles.position[position]};
    ${({ variant }) => sectionStyles.variant[variant]};
`;

export const InnerWrapper = styled(Box)<InnerWrapperProps>`
    ${({ boxed }) => sectionStyles.boxed[boxed]};
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    z-index: ${zIndex('base')};
`;

export const BackgroundWrapper = styled(Box)`
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
`;
